import React from "react";
import { throttle } from "throttle-debounce";
import { handleTooltipPosition } from "../utils/tooltip";

class Tooltip extends React.Component {
  constructor(props) {
    super(props);

    /* We use throttle to minimize the number of times we check window size
    this is important for performance
    */
    this.throttledHandleMouseMove = throttle(20, this.handleMouseMove);

    this.state = {
      active: false,
      data: this.props.data,
      tooltipPos: {
        x: 0,
        y: 0
      }
    };
  }

  componentDidMount() {
    window.addEventListener("mousemove", this.throttledHandleMouseMove);
  }

  componentWillUnmount() {
    window.removeEventListener("mousemove", this.throttledHandleMouseMove);
  }

  componentDidUpdate(prevProps, prevState) {
    // Update state if props change
    if (this.props.active !== prevProps.active) {
      this.setState({
        active: this.props.active
      });
    }
    if (this.props.data !== prevProps.data) {
      this.setState({
        data: this.props.data
      });
    }
  }

  handleMouseMove = e => {
    if (this.props.active) {
      const element = this.elementRef.getBoundingClientRect();
      const tooltipPos = handleTooltipPosition({
        mousePos: {
          x: e.pageX,
          y: e.pageY
        },
        tooltipDims: {
          height: element.height,
          width: element.width
        },
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight
        },
        mouseOffset: {
          x: 10,
          y: 10
        }
      });
      this.setState({
        mouse: {
          x: e.clientX,
          y: e.clientY
        },
        tooltipPos: tooltipPos
      });
    }
  };

  refCallback = element => {
    if (element) {
      this.elementRef = element;
    }
  };

  renderContent() {
    const { data } = this.state;
    return (
      <div className="tooltip__container-inner">
        <p className="tooltip__label">{data.label}</p>
        <p>{data.display}</p>
      </div>
    );
  }

  render() {
    const { active, tooltipPos } = this.state;
    return (
      <div>
        {active && (
          <div
            className="tooltip__container-outer"
            ref={this.refCallback}
            style={{
              left: tooltipPos.x + "px",
              top: tooltipPos.y + "px"
            }}
          >
            {this.renderContent()}
          </div>
        )}
      </div>
    );
  }
}

export default Tooltip;
